import { Constants } from '@pwc/pwc-deals-web-common';

export const layoutConfigs = {
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN]: {
    containerClass: 'two-column-layout',
    columnPositionClassMap: {
      LEFT: 1,
      RIGHT: 2,
    },
  },
  // layoutType : 3
  [Constants.SECTION_LAYOUT_TYPE.THREE_COLUMN]: {
    containerClass: 'section-grid one-row-three-column',
    columnPositionClassMap: {
      LEFT: 1,
      MIDDLE: 2,
      RIGHT: 3,
    },
  },
  [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN]: {},
  [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_80]: {
    containerClass: 'section-onecolumn2--eighty-percent',
  },
  [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_60]: {
    containerClass: 'section-onecolumn2--sixty-percent',
  },
  [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_40]: {
    containerClass: 'section-onecolumn2--forty-percent',
  },

  // layoutType: 7
  [Constants.SECTION_LAYOUT_TYPE.ONE_COLUMN_OVERFLOW_AREA]: {
    containerClass: 'section-onecolumn2--one-column-overflow',
  },

  [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_80_1A_B_20_1A]: {
    containerClass: 'section-grid two-row-t80-1a-b20-1a',
    columnPositionClassMap: {
      TOP: 1,
      BOTTOM: 2,
    },
  },
  [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_60_1A_B_40_1A]: {
    containerClass: 'section-grid two-row-t60-1a-b40-1a',
    columnPositionClassMap: {
      TOP: 1,
      BOTTOM: 2,
    },
  },
  [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_20_1A_B_80_1A]: {
    containerClass: 'section-grid two-row-t20-1a-b80-1a',
    columnPositionClassMap: {
      TOP: 1,
      BOTTOM: 2,
    },
  },
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_50_2A_R_50_1A]: {
    containerClass: 'section-grid two_column_left_50_2a_r_50_1a',
    columnPositionClassMap: {
      TOP_LEFT: 1,
      RIGHT: 2,
      BOTTOM_LEFT: 3,
    },
  },
  // layoutType: 9
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_50_3A_R_50_1A]: {
    containerClass: 'section-grid two-column-four-area-3left50-right50',
    columnPositionClassMap: {
      LEFT_FIRST: 1,
      RIGHT: 2,
      LEFT_SECOND: 3,
      LEFT_THIRD: 4,
    },
  },
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_40_1A_R_60_1A]: {
    containerClass: 'section-grid two-column-l40-1a-r60-1a',
    columnPositionClassMap: {
      LEFT: 1,
      RIGHT: 2,
    },
  },
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_67_1A_R_33_1A]: {
    containerClass: 'section-grid two-column-l67-1a-r33-1a',
    columnPositionClassMap: {
      LEFT: 1,
      RIGHT: 2,
    },
  },
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_67_2A_R_33_1A]: {
    containerClass: 'section-grid two-column-left-67-2a-right-33-1a',
    columnPositionClassMap: {
      LEFT_FIRST: 1,
      RIGHT: 2,
      LEFT_SECOND: 3,
      LEFT_THIRD: 4,
    },
  },
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_L_80_1A_R_20_1A]: {
    containerClass: 'section-grid two-column-l80-1a-r20-1a',
    columnPositionClassMap: {
      LEFT: 1,
      RIGHT: 2,
    },
  },
  [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_50_2A_B_50_1A]: {
    containerClass: 'section-grid two_column_t_50_2a_b_50_1a',
    columnPositionClassMap: {
      LEFT: 1,
      RIGHT: 2,
      BOTTOM: 3,
    },
  },
  [Constants.SECTION_LAYOUT_TYPE.TWO_ROW_T_50_1A_B_50_2A]: {
    containerClass: 'stack-two-block-bottom',
    columnPositionClassMap: {
      TOP: 1,
      BOTTOM_LEFT: 2,
      BOTTOM_RIGHT: 3,
    },
  },
  // layoutType: 19
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_TWO_ROW_50_2A_50_2A]: {
    containerClass: 'section-grid two-row-two-column-50-50',
    columnPositionClassMap: {
      TOP_LEFT: 1,
      TOP_RIGHT: 2,
      BOTTOM_LEFT: 3,
      BOTTOM_RIGHT: 4,
    },
  },
  // layoutType: 20
  [Constants.SECTION_LAYOUT_TYPE.TWO_COLUMN_TWO_ROW_67_2A_33_2A]: {
    containerClass: 'section-grid four-block-narrow-right',
    columnPositionClassMap: {
      TOP_LEFT: 1,
      TOP_RIGHT: 2,
      BOTTOM_LEFT: 3,
      BOTTOM_RIGHT: 4,
    },
  },
  // layoutType: 21
  [Constants.SECTION_LAYOUT_TYPE.THREE_COLUMN_TWO_ROW]: {
    containerClass: 'section-grid two-row-three-column',
    columnPositionClassMap: {
      TOP_LEFT: 1,
      TOP_MIDDLE: 2,
      TOP_RIGHT: 3,
      BOTTOM_LEFT: 4,
      BOTTOM_MIDDLE: 5,
      BOTTOM_RIGHT: 6,
    },
  },
};
